import React, {Component} from "react"
import PropTypes from "prop-types"

import Form from "@irati/ui/src/Form"
import Input from "@irati/ui/src/FormItem/Input"
import Validation from "@irati/utils/validation"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import {Body, H1} from "@irati/ui/src/Typography"

import SagaStep from "./SagaStep"

class Email extends Component {
  emailValidation = () => {
    return Validation
      .string("platform.defaultLogin.fields.emailValidation.enterEmail")
      .email("platform.defaultLogin.fields.emailValidation.notValid")
  }
  render() {
    const {onChange, email, formatMessage} = this.props
    return (
      <>
        <SagaStep />
        <H1 marginBottom={2}>
          <FormattedMessage id="perks.components.productForms.email.header" />
        </H1>
        <Form>
          <Input
            label={formatMessage({id: "perks.components.productForms.email.label.enterEmail"})}
            name="email"
            value={email}
            style={{marginBottom: "10px"}}
            placeholder={formatMessage({id: "perks.components.productForms.email.placeholder.emailAddress"})}
            validation={this.emailValidation()}
            onChange={(value) => onChange(value)} />
          <Body small>
            <FormattedMessage id="perks.components.productForms.email.helpText" />
          </Body>
        </Form>
      </>
    )
  }
}
Email.defaultProps = {
  email: ""
}
Email.propTypes = {
  email: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired
}

export default injectIntl(Email)
